// 4e ligne (Lucas, 27/10/2026 : « une ligne sans doubles, avec les autres
// annonces des autres lignes ») : toutes les annonces des catégories qui
// n'ont PAS leur propre ligne, mélangées, les plus récentes d'abord. Une
// annonce n'appartient qu'à une catégorie : aucune ne peut déjà figurer
// au-dessus (la déduplication du rendu le garantit en plus).
export const AUTRES_ANNONCES_MAX = 12;
export const ligneAutresAnnonces = (rows, lignesAffichees) => {
  const dejaLa = new Set((lignesAffichees || []).map((r) => r.category));
  const vus = new Set();
  const date = (l) => Date.parse(l.bumped_at || l.created_at || "") || 0;
  return (rows || [])
    .filter((r) => !dejaLa.has(r.category))
    .flatMap((r) => r.listings || [])
    .filter((l) => l && l.listing_id && !vus.has(l.listing_id) && vus.add(l.listing_id))
    .sort((a, b) => date(b) - date(a))
    .slice(0, AUTRES_ANNONCES_MAX);
};
